<template>
    <v-layout justify-space-between pa-3 wrap>
        <v-flex xs12 md5>
            <workflow-tree 
                :items="treeItems" 
                :currentSelectedItem="selectedItem"
                @itemSelected="treeItemIsSelected"
                @branchOpened="branchOpened">
            </workflow-tree>
        </v-flex>
        <v-flex xs12 md7>          
            <transition mode="out-in" name="workflowdetailcontainer" enter-active-class="fadeIn custom" leave-active-class="fadeOut custom-speed">
            
            <div v-if="!selectedItem" class="animated title grey--text text--lighten-1 font-weight-light" style="align-self: center;">
              Selecteer een item om te bewerken
            </div>
            <v-card v-if="selectedItem && isEvent" class="pt-4 animated">
                <unit-type-event-form 
                    @saved="unitTypeEventFormUpdated"    
                    @cancelClicked="cancelClicked"    
                    :unitTypeEvent="selectedData" 
                    :unitTypeId="unitTypeId"                                                    
                    :parentActionId="selectedEventParentActionId" 
                    :parentActionRelationType="selectedEventParentActionRelationType"
                    :hideWorkFlowButton="true"
                    >
                </unit-type-event-form>      
            </v-card>         

            <v-card v-if="selectedItem && isAction" class="pt-4 animated">
                <unit-type-event-action-form
                    @saved="unitTypeEventActionFormUpdated"
                    @cancelClicked="cancelClicked"
                    :unitTypeEventId="selectedActionParentUnitTypeEventId"
                    :unitTypeEventAction="selectedData"
                    >
                </unit-type-event-action-form>                
            </v-card>          

            </transition>
        </v-flex>
      </v-layout>
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import Notification from "../../components/global/Notification"
    import UnitTypeEventForm from "../../components/event/unitTypeEventForm"
    import UnitTypeEventActionForm from "../../components/event/unitTypeEventActionForm"
    import WorkflowTree from "../../components/workflow/workflowTree"

    export default {
        props:{ 
            unitTypeId:{
                required:true
            },
            rootUnitTypeEvent:{
                type:Object
            }
        },               
        data() {
            return {   
                treeItems:[],  
                selectedItem:null
            }
        },
        methods: {
           treeItemIsSelected(e){         
                let treeItem = e                

                // quick and dirty solution for now (form panel wont load correct data if itemType is the same as previous selected itemType so set to null before setting new one)
                this.selectedItem = null                
                let vm = this                
                this.$nextTick().then(() => {
                    vm.selectedItem = treeItem
                })                
            },
            branchOpened(e){
                let treeItem = e
                this.checkDeepload(treeItem)
            },
            unitTypeEventFormUpdated(e){    
                let updatedUnitTypeEvent = e   
    
                this.$store.dispatch(types.UNIT_TYPE_EVENT,{data:{id:updatedUnitTypeEvent.id}, params:{include:'parentAction, eventActions, eventType, eventSeverity'}}).then((unitTypeEvent)=>{
                    let treeItem = this.buildEventBranch(unitTypeEvent) 
                    // update on current selectedItemId (it will overwrite new_cancel and new_done tree nodes with the created one                                        
                    this.updateItem(this.treeItems, this.selectedItem.id ,treeItem)

                    // then overwrite the existing selected item with the refreshed one
                    // this.selectedItem = null
                    this.selectedItem = treeItem
                    
                    this.$notify(`Event:  ${this.selectedItem.name} is aangepast`, {color:'success', timeout: 4000, icon:'check'})             
                })                                            
            },   
            unitTypeEventActionFormUpdated(e){
                let updatedUnitTypeEventAction = e                                                                
                // reload Parent event to update branch, use a finished function so that the selectedItem is set after tree has rebuild
                this.getUnitTypeEvent(updatedUnitTypeEventAction.unitTypeEventId, (vm) => {
                    let item =  vm.findItem(vm.treeItems, "action_"+updatedUnitTypeEventAction.id)                    
                    vm.selectedItem = item ? item : null
                })
            },
            cancelClicked(){
                this.selectedItem=null
            },               
            checkDeepload(treeItem){
              // Start the lazy load on action
                if(treeItem.itemType == "action"){                        
                    if(treeItem.data.unitTypeEventCancelId && this.findItem("event_"+treeItem.data.unitTypeEventCancelId)){                                                
                        this.getUnitTypeEvent(treeItem.data.unitTypeEventCancelId)
                    }
                    if(treeItem.data.unitTypeEventDoneId && this.findItem("event_"+treeItem.data.unitTypeEventDoneId)){                        
                        this.getUnitTypeEvent(treeItem.data.unitTypeEventDoneId)
                    }                                      
                }
            },
// METHODS FOR BUILDING TREE DATA STRUCTURE -----------------------------------------------------------------------------------------------------------------
            getUnitTypeEvent(unitTypeEventId, finishedFunction) {   
                let vm = this             
                this.$store.dispatch(types.UNIT_TYPE_EVENT,{data:{id:unitTypeEventId}, params:{include:'parentAction, eventActions, eventType, eventSeverity'}}).then((unitTypeEvent)=>{
                    let treeItem = this.buildEventBranch(unitTypeEvent)                    
                    vm.buildEventinTree(unitTypeEvent)      
                    
                    if(finishedFunction){
                        finishedFunction(vm);
                    }                                 
                })                
            },    
            buildEventinTree(unitTypeEvent){

                let parentId = (unitTypeEvent.parentAction && unitTypeEvent.parentAction.id) ? 'action_'+unitTypeEvent.parentAction.id : false
                let treeItem = this.buildEventBranch(unitTypeEvent) 

                // if item not found in tree and does not have a parentAction, add as root item
                if(!this.findItem(this.treeItems, treeItem.id) && !parentId){                                        
                    this.$set(this.treeItems, this.treeItems.length, treeItem)
                }                
                // item found so update
                else if(this.findItem(this.treeItems, treeItem.id)){
                    this.updateItem(this.treeItems, treeItem.id, treeItem)
                }
                else{ // append item                    
                    this.appendItem(this.treeItems, parentId ,treeItem)
                }              
            },
            buildEventBranch(unitTypeEvent){
                let eventBranch = {id:"event_"+unitTypeEvent.id, name:unitTypeEvent.name, objectType:'event', children:[], data: unitTypeEvent}

                if(unitTypeEvent.isCancelEvent)
                    eventBranch.itemType = "cancel_event"
                else if(unitTypeEvent.isDoneEvent)
                    eventBranch.itemType = "done_event"
                else
                    eventBranch.itemType = "root_event"
            
                if(unitTypeEvent.eventActions){
                    for(let i in unitTypeEvent.eventActions){              
                        eventBranch.children.push( this.buildActionBranch(unitTypeEvent.eventActions[i], unitTypeEvent.id) )
                    } 
                }
                eventBranch.children.push({id:"action_new_on_event_"+unitTypeEvent.id, itemType:"new_action",objectType:"action", name:"Maak nieuwe aktie aan", new:true, parent_event_id:unitTypeEvent.id})

                return eventBranch
            },
            buildActionBranch(unitTypeEventAction, parentEventId){
                let actionBranch = {id:"action_"+unitTypeEventAction.id, 
                                    itemType:"action", 
                                    objectType:'action', 
                                    name:unitTypeEventAction.name, 
                                    children:[], 
                                    data:unitTypeEventAction, 
                                    parent_event_id:parentEventId}

                // add new option for new event done on action if done event is not set yet
                if(!unitTypeEventAction.unitTypeEventDoneId){
                    actionBranch.children.push({id:'new_done_event_on_action_'+unitTypeEventAction.id,                                                
                                                name:'Maak afgerond event aan',
                                                itemType:'new_done_event', 
                                                objectType:'event',
                                                new:true, 
                                                action_event_type: "done",   
                                                parent_action_id:unitTypeEventAction.id,                                             
                                                data:unitTypeEventAction}
                                           )
                }                
                // add option for new event cancel on action if cancel event is not set yet
                if(!unitTypeEventAction.unitTypeEventCancelId){
                    actionBranch.children.push({id:'new_cancel_event_on_action_'+unitTypeEventAction.id,
                                                name:'Maak anuleer event aan', 
                                                itemType:'new_cancel_event', 
                                                objectType:'event',
                                                new:true,
                                                action_event_type:"cancel",   
                                                parent_action_id:unitTypeEventAction.id,                                             
                                                data:unitTypeEventAction}
                                            )
                }
                return actionBranch
            },     
        // TREE MUTATION METHODS --------------------------------------------------------------------------------------------------------------                     
            updateItem(collection, itemId, updateItem){                
                for(let i in collection){               
                    if(collection[i].id == itemId){                        
                        this.$set(collection, i, updateItem)
                        return true
                    }
                    else if(collection[i].children){                
                        // item for update found pass on true         
                        if(this.updateItem(collection[i].children, itemId, updateItem)){
                            return true                                         
                        }
                    }
                } 
                return false 
            },
            appendItem(collection, parentId, newItem){
                for(let i in collection){               
                    if(collection[i].id == parentId){                                                       
                        this.$set(collection[i].children, collection[i].children.length, newItem )
                        return true
                    }                    
                    else if(collection[i].children){                         
                        // item for update found pass on true                        
                        if(this.appendItem(collection[i].children, parentId, newItem)){
                            return true
                        }                                         
                    }
                } 
                return false                 
            },
            findItem(collection, itemId){
                for(let i in collection){
                    if(collection[i].id == itemId)
                        return collection[i]
                    else if(collection[i].children){                         
                        let found = this.findItem(collection[i].children, itemId)
                        if(found !== false){
                            return found
                        }                                            
                    }
                }
                return false
            },                                       
        },
        computed: {
            isEvent(){
                return this.selectedItem.objectType == "event" ? true : false
            },
            isAction(){
                return this.selectedItem.objectType == "action" ? true : false
            },
            selectedData(){
                return this.selectedItem.new ? null : this.selectedItem.data
            },
            selectedEventParentActionId(){
                return (this.isEvent && this.selectedItem.new) ? this.selectedItem.parent_action_id : 0
            },            
            selectedEventParentActionRelationType(){
                return (this.isEvent && this.selectedItem.new) ? this.selectedItem.action_event_type : "none"
            },         
            selectedActionParentUnitTypeEventId(){
                return this.isAction ? this.selectedItem.parent_event_id : 0
            }     
        },
        components:{
            Notification,
            UnitTypeEventForm,
            UnitTypeEventActionForm,
            WorkflowTree
        },
        mounted(){
            if(this.rootUnitTypeEvent){            
                this.getUnitTypeEvent(this.rootUnitTypeEvent.id)
            }
            //    this.treeItems = [{id:0,name:"geen unitTypeEvent gegeven", itemType:"new_cancel_event"}]            
        }
    }
</script>

<style scoped>
    .custom-speed {
       animation-duration: 300ms; 
    }   
</style>